let dictMap = new Map()
dictMap.set(301,'子女')
dictMap.set(302,'自己及配偶')
dictMap.set(303,'父母')
dictMap.set(333,'体检')
dictMap.set(401,'老人')
dictMap.set(411,'中青年')
dictMap.set(421,'少年儿童')
dictMap.set(431,'心智宝')
dictMap.set(441,'体检')
dictMap.set(501,'意外险')
dictMap.set(502,'责任险')
dictMap.set(503,'救援险')
dictMap.set(504,'重疾险')
dictMap.set(505,'视力障碍')
dictMap.set(555,'体检')

const Config = {
    wxAppId: {
        0: 'wx7846f565347ca496', //易宝公众号appId
        1: 'wxa677ab25b5f78706', //心智宝微信公众号appId,
        3: 'wx7846f565347ca496',
        100 : 'wxa49e85fdf6a8e019' //测试公众号

    },
    timeout: 2000,  //接口超时时间
    dictMap: dictMap

}



export default Config
